import * as React from "react";
import BikeDeatils from "../components/vehicle-details/bike.jsx";

export default function BikeDetails() {
  return (
    <>
      <BikeDeatils />
    </>
  );
}
